var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSouth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2126 17.4126L16.1126 14.5126C16.2959 14.3293 16.5292 14.2376 16.8126 14.2376C17.0959 14.2376 17.3292 14.3293 17.5126 14.5126C17.6959 14.696 17.7876 14.9293 17.7876 15.2126C17.7876 15.496 17.6959 15.7293 17.5126 15.9126L12.9126 20.5126C12.8126 20.6126 12.7042 20.6835 12.5876 20.7251C12.4709 20.7668 12.3459 20.7876 12.2126 20.7876C12.0792 20.7876 11.9542 20.7668 11.8376 20.7251C11.7209 20.6835 11.6126 20.6126 11.5126 20.5126L6.91257 15.9126C6.72924 15.7293 6.63757 15.496 6.63757 15.2126C6.63757 14.9293 6.72924 14.696 6.91257 14.5126C7.09591 14.3293 7.32924 14.2376 7.61257 14.2376C7.89591 14.2376 8.12924 14.3293 8.31257 14.5126L11.2126 17.4126L11.2126 4.21265C11.2126 3.92931 11.3084 3.69181 11.5001 3.50015C11.6917 3.30848 11.9292 3.21265 12.2126 3.21265C12.4959 3.21265 12.7334 3.30848 12.9251 3.50015C13.1167 3.69181 13.2126 3.92931 13.2126 4.21265L13.2126 17.4126Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouth);
export default __webpack_public_path__ + "static/media/South.7c34979d.svg";
export { ForwardRef as ReactComponent };